import React, { useEffect } from 'react';
import Environment, { ENVIRONMENT_TYPE } from '../../services/Environment';

function AddMetaRobots() {
  useEffect(() => {
    if (Environment.isEnvironment(ENVIRONMENT_TYPE.TEST)) {
        // Create meta tag
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';

        // Append it to the head
        document.head.appendChild(meta);

        // Cleanup on unmount
        return () => {
            document.head.removeChild(meta);
        };
    }
    
  }, []);

  return null; // This component doesn't render anything
}

export default AddMetaRobots;
